import React from 'react';
import { Typography, Box, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { LegalPageLayout, useLegalStyles } from './LegalPageLayout';

export const TermsAndConditions: React.FC = () => {
  const classes = useLegalStyles();

  return (
    <LegalPageLayout title="Termini e Condizioni di Vendita" lastUpdate="11 dicembre 2024">
      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          1. Premessa e Definizioni
        </Typography>
        <Typography className={classes.paragraph}>
          Le presenti Condizioni Generali di Vendita disciplinano l'offerta e la vendita di prodotti agricoli biologici
          e convenzionali attraverso il sito web lortocompagnoni.it (di seguito "Sito").
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Venditore:</strong> Società Agricola L'orto Dei F.lli Compagnoni S.s., con sede legale in Via
          Baccanina, 2 - 41037 Mirandola (MO), P.IVA 03824940369, di seguito denominata "L'Orto" o "Venditore".
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Cliente/Consumatore:</strong> la persona fisica che effettua acquisti sul Sito per scopi estranei
          all'attività imprenditoriale, commerciale, artigianale o professionale eventualmente svolta.
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Prodotti:</strong> frutta, verdura, ortaggi e altri prodotti agricoli freschi, sia biologici che
          convenzionali, coltivati e commercializzati da L'Orto.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          2. Modalità di Acquisto
        </Typography>
        <Typography className={classes.paragraph}>Il Sito offre due modalità di acquisto:</Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
          2.1 Consegna Diretta (Zona Mirandola e Limitrofi)
        </Typography>
        <Typography className={classes.paragraph}>
          Servizio di consegna a domicilio disponibile nei comuni di Mirandola, Carpi e zone limitrofe. Gli ordini
          vengono consegnati secondo la programmazione settimanale comunicata sul sito. Il pagamento avviene alla
          consegna.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2.2 Vendita Online con Spedizione
        </Typography>
        <Typography className={classes.paragraph}>
          Servizio di vendita con spedizione tramite corriere in tutta Italia (isole escluse). Il pagamento avviene
          online tramite carta di credito/debito attraverso la piattaforma sicura Stripe.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          3. Registrazione e Account
        </Typography>
        <Typography className={classes.paragraph}>
          Per effettuare acquisti è necessario registrarsi al Sito fornendo dati veritieri e completi. L'utente è
          responsabile della riservatezza delle proprie credenziali di accesso e di tutte le attività compiute
          attraverso il proprio account.
        </Typography>
        <Typography className={classes.paragraph}>È vietato:</Typography>
        <ul className={classes.list}>
          <li>Fornire dati falsi o di terzi</li>
          <li>Creare account multipli</li>
          <li>Cedere o condividere le credenziali con terzi</li>
          <li>Utilizzare l'account per attività illecite</li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          4. Prodotti, Prezzi e Disponibilità
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
          4.1 Natura dei Prodotti
        </Typography>
        <Typography className={classes.paragraph}>
          I prodotti in vendita sono prodotti agricoli freschi, soggetti a stagionalità. Le immagini presenti sul Sito
          sono puramente indicative e potrebbero non rappresentare fedelmente il prodotto consegnato, che può variare
          per dimensione, forma e colore in quanto prodotto naturale.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4.2 Prezzi
        </Typography>
        <Typography className={classes.paragraph}>
          I prezzi indicati sul Sito sono espressi in Euro e si intendono IVA inclusa (ove applicabile). Per i prodotti
          agricoli venduti da produttori agricoli con volume d'affari inferiore a determinati limiti, potrebbe
          applicarsi il regime di esonero IVA ai sensi dell'art. 34, comma 6, DPR 633/72.
        </Typography>
        <Typography className={classes.paragraph}>
          I prezzi possono variare in base alla disponibilità e alla stagionalità dei prodotti. Il prezzo applicato è
          quello in vigore al momento dell'ordine.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4.3 Disponibilità
        </Typography>
        <Typography className={classes.paragraph}>
          La disponibilità dei prodotti è soggetta a variazioni in base alla stagione e alla produzione agricola. In
          caso di indisponibilità di un prodotto ordinato, il Cliente sarà tempestivamente informato e potrà scegliere
          tra:
        </Typography>
        <ul className={classes.list}>
          <li>Attendere la disponibilità del prodotto</li>
          <li>Sostituire il prodotto con uno equivalente</li>
          <li>Ottenere il rimborso del prezzo pagato per il prodotto non disponibile</li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          5. Ordini e Conclusione del Contratto
        </Typography>
        <Typography className={classes.paragraph}>
          L'ordine effettuato dal Cliente costituisce proposta contrattuale. Il contratto di vendita si conclude nel
          momento in cui il Cliente riceve conferma dell'ordine via email.
        </Typography>
        <Typography className={classes.paragraph}>
          L'Orto si riserva il diritto di non accettare ordini incompleti, con dati errati, o da utenti che risultino
          inadempienti per precedenti acquisti.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          6. Pagamenti
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
          6.1 Consegna Diretta
        </Typography>
        <Typography className={classes.paragraph}>
          Per gli ordini con consegna diretta, il pagamento avviene in contanti o tramite POS alla consegna.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6.2 Vendita Online
        </Typography>
        <Typography className={classes.paragraph}>
          Per gli ordini con spedizione, il pagamento avviene online tramite carta di credito/debito attraverso la
          piattaforma Stripe. I dati della carta non vengono mai memorizzati sui nostri server. Stripe è certificato
          PCI-DSS Level 1.
        </Typography>
        <Typography className={classes.paragraph}>Carte accettate: Visa, Mastercard, American Express.</Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          7. Spedizioni e Consegne
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
          7.1 Tempi di Consegna
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Consegna diretta:</strong> secondo il calendario settimanale pubblicato sul Sito.
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Spedizione nazionale:</strong> 24-48 ore lavorative dalla spedizione (escluse isole). Gli ordini
          vengono preparati e spediti entro 24 ore lavorative dalla conferma del pagamento.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7.2 Costi di Spedizione
        </Typography>
        <Typography className={classes.paragraph}>
          I costi di spedizione sono calcolati automaticamente in fase di checkout in base al peso e alla destinazione
          dell'ordine. Per la consegna diretta, le spese di consegna sono indicate nell'apposita sezione del Sito.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7.3 Zone Escluse
        </Typography>
        <Typography className={classes.paragraph}>
          Le spedizioni non sono disponibili per Sicilia e Sardegna a causa della deperibilità dei prodotti freschi e
          dei tempi di transito prolungati.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7.4 Verifica alla Consegna
        </Typography>
        <Typography className={classes.paragraph}>
          Il Cliente è tenuto a verificare l'integrità del pacco al momento della consegna. In caso di danni evidenti
          all'imballaggio, è necessario accettare la consegna con riserva scritta o rifiutarla, segnalando
          immediatamente il problema a L'Orto.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          8. Diritto di Recesso
        </Typography>
        <Typography className={classes.paragraph}>
          Ai sensi dell'art. 59, comma 1, lettera d) del Codice del Consumo (D.Lgs. 206/2005), il diritto di recesso è{' '}
          <strong>escluso</strong> per i prodotti alimentari freschi e deperibili, quali frutta, verdura e ortaggi, che
          costituiscono la totalità dei prodotti venduti sul Sito.
        </Typography>
        <Typography className={classes.paragraph}>
          Questa esclusione è dovuta alla natura deperibile dei prodotti, che per loro caratteristica intrinseca
          rischiano di deteriorarsi rapidamente.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          9. Garanzia e Reclami
        </Typography>
        <Typography className={classes.paragraph}>
          L'Orto garantisce la qualità e la freschezza dei prodotti al momento della spedizione. In caso di prodotti
          danneggiati, deteriorati o non conformi, il Cliente deve:
        </Typography>
        <ul className={classes.list}>
          <li>Segnalare il problema entro 24 ore dalla consegna</li>
          <li>Documentare il problema con fotografie</li>
          <li>Conservare i prodotti e l'imballaggio per eventuali verifiche</li>
        </ul>
        <Typography className={classes.paragraph}>
          Dopo la verifica, L'Orto provvederà, a sua discrezione, alla sostituzione del prodotto o al rimborso del
          prezzo pagato.
        </Typography>
        <Typography className={classes.paragraph}>
          Per segnalazioni e reclami contattare: negozio@lortocompagnoni.it o telefono 339 540 8713.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          10. Limitazione di Responsabilità
        </Typography>
        <Typography className={classes.paragraph}>L'Orto non sarà responsabile per:</Typography>
        <ul className={classes.list}>
          <li>Ritardi nella consegna dovuti al corriere o a cause di forza maggiore</li>
          <li>Deterioramento dei prodotti dovuto a errata conservazione da parte del Cliente dopo la consegna</li>
          <li>Danni indiretti o consequenziali</li>
          <li>Malfunzionamenti del Sito dovuti a problemi tecnici di terze parti o forza maggiore</li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          11. Privacy e Protezione dei Dati
        </Typography>
        <Typography className={classes.paragraph}>
          Il trattamento dei dati personali avviene nel rispetto del Regolamento UE 2016/679 (GDPR) e della normativa
          italiana. Per tutti i dettagli, consulta la nostra{' '}
          <Link component={RouterLink} to="/privacy-policy">
            Informativa sulla Privacy
          </Link>
          .
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          12. Proprietà Intellettuale
        </Typography>
        <Typography className={classes.paragraph}>
          Tutti i contenuti del Sito (testi, immagini, loghi, grafica) sono di proprietà di L'Orto o concessi in licenza
          e sono protetti dalle leggi sul diritto d'autore. È vietata qualsiasi riproduzione, distribuzione o utilizzo
          non autorizzato.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          13. Legge Applicabile e Foro Competente
        </Typography>
        <Typography className={classes.paragraph}>
          Le presenti Condizioni sono regolate dalla legge italiana. Per qualsiasi controversia derivante
          dall'interpretazione o esecuzione delle presenti Condizioni sarà competente in via esclusiva il Foro del luogo
          di residenza o domicilio del Consumatore, se ubicati in Italia.
        </Typography>
        <Typography className={classes.paragraph}>
          Il Consumatore residente in Europa può inoltre ricorrere alla piattaforma ODR (Online Dispute Resolution) per
          la risoluzione alternativa delle controversie:{' '}
          <Link href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </Link>
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          14. Modifiche alle Condizioni
        </Typography>
        <Typography className={classes.paragraph}>
          L'Orto si riserva il diritto di modificare le presenti Condizioni in qualsiasi momento. Le modifiche saranno
          efficaci dalla data di pubblicazione sul Sito. Gli ordini effettuati prima della pubblicazione delle modifiche
          rimarranno soggetti alle Condizioni in vigore al momento dell'ordine.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          15. Contatti
        </Typography>
        <Typography className={classes.paragraph}>
          Per qualsiasi informazione o richiesta relativa alle presenti Condizioni:
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Società Agricola L'orto Dei F.lli Compagnoni S.s.</strong>
          <br />
          Via Baccanina, 2 - 41037 Mirandola (MO)
          <br />
          P.IVA: 03824940369
          <br />
          Telefono: 339 540 8713
          <br />
          Email: negozio@lortocompagnoni.it
        </Typography>
      </Box>
    </LegalPageLayout>
  );
};
